import React, { useContext, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { AppContext } from '../../context/AppContextProvider'
import { SalesType } from '../../util/constants'
import { detectMacOs, detectNumberCount, formatAndRoundPrize } from '../../util/util'
import MobileNumber from './MobileNumber'
import OtpNumber from './OtpNumber'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import PurchaseConfirm from './PurchaseConfirm'
import NICNumber from './NICNumber'
import PurchaseComplete from './PurchaseComplete'
import CountDown from '../../components/CountDown'
import 'bootstrap/dist/css/bootstrap.min.css'

const LottoBaseHome = () => {
  const { lotto } = useParams()
  const { lotteryState, setLotteryState, setPackageState, setSalesType } = useContext(AppContext)
  const { globalLoader, themeState, setThemeState } = useContext(MessageHandlerContext)
  const { authState } = useContext(AuthContext)
  const {
    mobileNumberModal, setMobileNumberModal,
    otpModal, setOtpModal,
    nicModal, setNicModal,
    purchaseCompleteModal, setPurchaseCompleteModal,
    purchaseConfirmModal, setPurchaseConfirmModal
  } = useContext(ModalContext)

  const canvasRef = useRef(null)

  const formattedPrize = formatAndRoundPrize(lotteryState && lotteryState.jackpot)
  const spacing = detectNumberCount(formattedPrize.amount)

  useEffect(() => {
    setTheme()
    const cleanup = startFireworks()
    return cleanup
  }, [lotto])

  const setTheme = () => {
    switch (lotto) {
      case 'Govi Setha':
        setThemeState('gs')
        setLotteryState({ jackpot: window.env.GS_JACKPOT_PRICE, drawId: window.env.GS_DRAW_ID, draw_number: window.env.GS_DRAW, draw_date: window.env.GS_DRAW_DATE, draw_date_time: window.env.GS_DRAW_END_TIME })
        setPackageState(window.env.GS_PACKAGE_ID)
        break
      case 'Supiri Vasana':
        setThemeState('sw')
        setLotteryState({ jackpot: window.env.SW_JACKPOT_PRICE, drawId: window.env.SW_DRAW_ID, draw_number: window.env.SW_DRAW, draw_date: window.env.SW_DRAW_DATE, draw_date_time: window.env.SW_DRAW_END_TIME })
        setPackageState(window.env.SW_PACKAGE_ID)
        break
      case 'Mahajana Sampatha':
        setThemeState('ms')
        setLotteryState({ jackpot: window.env.MS_JACKPOT_PRICE, drawId: window.env.MS_DRAW_ID, draw_number: window.env.MS_DRAW, draw_date: window.env.MS_DRAW_DATE, draw_date_time: window.env.MS_DRAW_END_TIME })
        setPackageState(window.env.MS_PACKAGE_ID)
        break
      case 'Dhana Nidhanaya':
        setThemeState('dn')
        setLotteryState({ jackpot: window.env.DN_JACKPOT_PRICE, drawId: window.env.DN_DRAW_ID, draw_number: window.env.DN_DRAW, draw_date: window.env.DN_DRAW_DATE, draw_date_time: window.env.DN_DRAW_END_TIME })
        setPackageState(window.env.DN_PACKAGE_ID)
        break
      case 'Mega Power':
        setThemeState('mp')
        setLotteryState({ jackpot: window.env.MP_JACKPOT_PRICE, drawId: window.env.MP_DRAW_ID, draw_number: window.env.MP_DRAW, draw_date: window.env.MP_DRAW_DATE, draw_date_time: window.env.MP_DRAW_END_TIME })
        setPackageState(window.env.MP_PACKAGE_ID)
        break
      case 'Vasana Sampatha':
        setThemeState('ws')
        setLotteryState({ jackpot: window.env.WS_JACKPOT_PRICE, drawId: window.env.WS_DRAW_ID, draw_number: window.env.WS_DRAW, draw_date: window.env.WS_DRAW_DATE, draw_date_time: window.env.WS_DRAW_END_TIME })
        setPackageState(window.env.WS_PACKAGE_ID)
        break
      case 'Hadahana':
        setThemeState('hd')
        setLotteryState({ jackpot: window.env.HD_JACKPOT_PRICE, drawId: window.env.HD_DRAW_ID, draw_number: window.env.HD_DRAW, draw_date: window.env.HD_DRAW_DATE, draw_date_time: window.env.HD_DRAW_END_TIME })
        setPackageState(window.env.HD_PACKAGE_ID)
        break
      case 'Jathika Sampatha':
        setThemeState('js')
        setLotteryState({ jackpot: window.env.JS_JACKPOT_PRICE, drawId: window.env.JS_DRAW_ID, draw_number: window.env.JS_DRAW, draw_date: window.env.JS_DRAW_DATE, draw_date_time: window.env.JS_DRAW_END_TIME })
        setPackageState(window.env.JS_PACKAGE_ID)
        break
      case 'Lucky 7':
        setThemeState('l7')
        setLotteryState({ jackpot: window.env.L7_JACKPOT_PRICE, drawId: window.env.L7_DRAW_ID, draw_number: window.env.L7_DRAW, draw_date: window.env.L7_DRAW_DATE, draw_date_time: window.env.L7_DRAW_END_TIME })
        setPackageState(window.env.L7_PACKAGE_ID)
        break
      case 'Ada Sampatha':
        setThemeState('as')
        setLotteryState({ jackpot: window.env.AS_JACKPOT_PRICE, drawId: window.env.AS_DRAW_ID, draw_number: window.env.AS_DRAW, draw_date: window.env.AS_DRAW_DATE, draw_date_time: window.env.AS_DRAW_END_TIME })
        setPackageState(window.env.AS_PACKAGE_ID)
        break
      case 'NLB Jaya':
        setThemeState('nj')
        setLotteryState({ jackpot: window.env.NJ_JACKPOT_PRICE, drawId: window.env.NJ_DRAW_ID, draw_number: window.env.NJ_DRAW, draw_date: window.env.NJ_DRAW_DATE, draw_date_time: window.env.NJ_DRAW_END_TIME })
        setPackageState(window.env.NJ_PACKAGE_ID)
        break
      case 'Subha Dawasak':
        setThemeState('sd')
        setLotteryState({ jackpot: window.env.SD_JACKPOT_PRICE, drawId: window.env.SD_DRAW_ID, draw_number: window.env.SD_DRAW, draw_date: window.env.SD_DRAW_DATE, draw_date_time: window.env.SD_DRAW_END_TIME })
        setPackageState(window.env.SD_PACKAGE_ID)
        break
      default:
        break
    }
  }

  const onBuyClick = (type) => {
    setSalesType(type)
    if (authState && authState.token) {
      setPurchaseConfirmModal(!purchaseConfirmModal)
    } else {
      setMobileNumberModal(!mobileNumberModal)
    }
  }

  const startFireworks = () => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')

    const particles = []
    const random = (min, max) => Math.random() * (max - min) + min

    const animationRef = { current: null }
    const intervalRef = { current: null }

    class Particle {
      constructor (x, y, color) {
        this.x = x
        this.y = y
        this.radius = 2
        this.color = color
        this.speedX = random(-3, 3)
        this.speedY = random(-3, 3)
        this.alpha = 1
        this.decay = random(0.01, 0.03)
      }

      update () {
        this.x += this.speedX
        this.y += this.speedY
        this.alpha -= this.decay
      }

      draw () {
        ctx.save()
        ctx.globalAlpha = this.alpha
        ctx.fillStyle = this.color
        ctx.beginPath()
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2)
        ctx.fill()
        ctx.restore()
      }
    }

    const createFirework = () => {
      const x = random(50, canvas.width - 50)
      const y = random(50, canvas.height / 2)
      const colors = ['#ff0040', '#ff8000', '#ffff00', '#00ff00', '#00ffff', '#0080ff', '#8000ff', '#ff00ff']
      Array.from({ length: 40 }).forEach(() => {
        const color = colors[Math.floor(Math.random() * colors.length)]
        particles.push(new Particle(x, y, color))
      })
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      particles.forEach((p, i) => {
        p.update()
        p.draw()
        if (p.alpha <= 0) particles.splice(i, 1)
      })
      animationRef.current = requestAnimationFrame(animate)
    }

    // Start fireworks
    createFirework()
    intervalRef.current = setInterval(createFirework, 1000)
    animate()

    // Stop after 6 seconds
    setTimeout(() => clearInterval(intervalRef.current), 6000)

    // Cleanup
    return () => {
      clearInterval(intervalRef.current)
      cancelAnimationFrame(animationRef.current)
      ctx.clearRect(0, 0, canvas.width, canvas.height)
    }
  }

  const renderMegaPowerLottery = () => {
    return (
      <div className='py-2'>
        <div className='lottery-wrapper'>
          <div className='MegapowerDrawText'>
            DRAW {lotteryState && lotteryState.draw_number} | DATE {lotteryState && lotteryState.draw_date}
          </div>
          <div className='MegapowerPriceText'>
            {formattedPrize.amount} {formattedPrize.suffix}
          </div>
          <div className='buttonforMP'>
            <button
              className='buttonInsideforMP'
              onClick={() => {
                onBuyClick(SalesType.ON_DEMAND)
              }}
            >
              BUY NOW
            </button>
          </div>
        </div>
      </div>
    )
  }

  const renderLottery = () => {
    if (lotto === 'Mega Power') {
      return renderMegaPowerLottery()
    }
    return (
      <div className='py-2'>
        <div className='lottery-wrapper'>
          <div className={`winning-prize-wrapper ${themeState}`}>
            {spacing !== 0 && <div className='winning-prize-currency' style={{ top: spacing.top, left: spacing.left }}>Rs</div>}
            <div className='draw-info'>
              DRAW {lotteryState && lotteryState.draw_number} | DATE {lotteryState && lotteryState.draw_date}
            </div>
            <div className={`winning-prize-amount ${themeState} prize-animate`} style={{ top: detectMacOs() ? -22 : -1 }}>
              {formattedPrize.amount}
            </div>
            <div className='winning-prize-suffix' style={{ bottom: detectMacOs() ? -16 : -22 }}>
              {formattedPrize.suffix}
            </div>
          </div>
          <div className='countdown-wraper-container'>
            <CountDown />
          </div>
          <div className={'button'}>
            <button
              className={`buy-button ${themeState} button-animate`}
              style={{ paddingTop: detectMacOs() ? 2 : 4 }}
              onClick={() => {
                onBuyClick(SalesType.ON_DEMAND)
              }}
            >
              BUY NOW
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='pos-rel h-100 widget-container' style={{ position: 'relative' }}>
      <canvas
        ref={canvasRef}
        className='fireworks-canvas'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1
        }}
      />
      <div style={{ position: 'relative', zIndex: 2 }}>
        {!globalLoader && renderLottery()}
        <MobileNumber opened={mobileNumberModal} toggle={() => setMobileNumberModal(!mobileNumberModal)} />
        <OtpNumber opened={otpModal} toggle={() => setOtpModal(!otpModal)} />
        <NICNumber opened={nicModal} toggle={() => setNicModal(!nicModal)} />
        <PurchaseConfirm opened={purchaseConfirmModal} toggle={() => setPurchaseConfirmModal(!purchaseConfirmModal)} />
        <PurchaseComplete opened={purchaseCompleteModal} toggle={() => setPurchaseCompleteModal(!purchaseCompleteModal)} />
      </div>
    </div>
  )
}

export default LottoBaseHome
